import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestUpdate() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              <i className="ri-time-line text-primary-500 mr-2"></i>
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              实时同步各大平台更新，精彩内容不错过
            </p>
          </div>
          <Link
            to="/category/dianshiju"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestUpdates.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 cursor-pointer transition-all duration-300"
            >
              <div className="relative w-20 h-28 md:w-24 md:h-32 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                {item.isHot && (
                  <div className="absolute top-1.5 left-1.5 px-1.5 py-0.5 rounded bg-accent-500 text-background-50 text-[10px] font-bold">
                    HOT
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs text-primary-500 font-medium mb-1">{item.episode}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span>{item.category}</span>
                  <span>·</span>
                  <span>{item.platform}</span>
                </div>
                <p className="text-xs text-foreground-300 mt-1.5">{item.updateTime}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}